export const SIGNUP_VERIFICATION_SESSION_KEY = "pending_signup_verification";

export interface PendingSignupVerification {
  email: string;
  fromSignup: boolean;
  vertical: string | null;
}

export function savePendingSignupVerification(
  pendingVerification: PendingSignupVerification,
): void {
  sessionStorage.setItem(
    SIGNUP_VERIFICATION_SESSION_KEY,
    JSON.stringify(pendingVerification),
  );
}

export function getPendingSignupVerification(): PendingSignupVerification | null {
  const value = sessionStorage.getItem(SIGNUP_VERIFICATION_SESSION_KEY);
  if (!value) {
    return null;
  }

  try {
    const parsed = JSON.parse(value) as Partial<PendingSignupVerification>;
    if (!parsed.email || typeof parsed.email !== "string") {
      return null;
    }

    return {
      email: parsed.email,
      fromSignup: parsed.fromSignup === true,
      vertical: typeof parsed.vertical === "string" ? parsed.vertical : null,
    };
  } catch {
    return null;
  }
}

export function clearPendingSignupVerification(): void {
  sessionStorage.removeItem(SIGNUP_VERIFICATION_SESSION_KEY);
}
